import { fixUrl } from "pages/MainPage/components/SocialMediaList/LogoBaseLink";
import { getFilmmakersSSOLink } from "shared-utils";

export const handleWebsite = (website?: string) => {
  if (!website) {
    return;
  }

  window.open(fixUrl(website), "_blank");
};

export const handleFilmmakers = (profileIdAttr: string) => {
  window.open(
    `https://www.filmmakers.eu/spotlight-redirect/${profileIdAttr}`,
    "_blank"
  );
};

export const handleRedirectToFilmmakers = async () => {
  const data = await getFilmmakersSSOLink(
    "https://www.filmmakers.eu/sso/spotlight/inbound"
  );
  window.open(data.url, "_blank");
};
